import axiosInstance from "../../../../../axiosInstance";
import {getDomain, getUserId} from "../../../Base/helper/baseFunctions";
import { HRMS_UTILITY_API_URL } from "../../../../Constants/baseConstant";
import { toast } from "react-toastify";


export const GetWhatsappConfigurationHelper = async (params) => {
    return await axiosInstance(`/whatsapp/getWhatsappConfiguration`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain : getDomain()
        }
    })
        .then(res => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpsertWhatsappConfigurationHelper = async (params) => {
    return await axiosInstance(`/whatsapp/upsertWhatsappConfiguration`, {
        method: "PUT",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: getDomain(),
            whatsapp_meta_token: params?.whatsapp_meta_token,
            whatsapp_business_number: params?.whatsapp_business_number,
            team_whatsapp_attendance_applicable: params?.team_whatsapp_attendance_applicable || false,
            individual_whatsapp_attendance_applicable: params?.individual_whatsapp_attendance_applicable || false,
            whatsapp_configuration_fk: params?.whatsapp_configuration_fk || null,
            user_id: getUserId(),
            phone_number_id: params?.phone_number_id
        }
    })
        .then(res => {
            toast.dismiss();
            toast.success("Configuration saved successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to save configuration");
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
}

export const TestWhatsappConfigurationHelper = async (params) => {
    return await axiosInstance(`/whatsapp/testMetaConnection`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            whatsapp_meta_token: params?.whatsapp_meta_token,
            whatsapp_business_number: params?.whatsapp_business_number
        }
    })
        .then(res => {
            toast.dismiss();
           params?.show && toast.success("WhatsApp connection verified successfully.");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
           params?.show && toast.error(err?.response?.data?.error?.[0]?.message || "Unable to validate WhatsApp connection");
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
}
